import { Component } from '@angular/core';
import { TruncatedContentCustomTooltipComponent } from 'shared/components/ag-grid/cell-renderers/truncated-content-tooltip-cell-renderer/truncated-content-custom-tooltip/truncated-content-custom-tooltip.component';
import { TooltipDirective } from 'shared/directives/tooltip.directive';

@Component({
    selector: 'app-truncated-content-tooltip-cell-renderer',
    imports: [TooltipDirective],
    templateUrl: './truncated-content-tooltip-cell-renderer.component.html',
    styleUrl: './truncated-content-tooltip-cell-renderer.component.scss',
})
export class TruncatedContentTooltipCellRendererComponent {
    public fullText: string = '';

    agInit(params: any): void {
        this.fullText = params.value != null ? String(params.value) : '';
    }

    truncatedContentCustomTooltipComponent = TruncatedContentCustomTooltipComponent;

    refresh(params: any): boolean {
        this.fullText = params.value != null ? String(params.value) : '';
        return true;
    }
}
